import React from 'react';
import SupportContent from '../features/support';

const Support = () => {
  return <SupportContent />;
};

export default Support;
